import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../../models/User';
import { Router } from '@angular/router';
import { Constants } from 'src/app/utils/constants';
import { AppConfigServiceService } from '../app-config-service.service';
import { HelpersService } from '../shared/helpers.service';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  private currentUsernameSubject: BehaviorSubject<string>;

  private hrefSource = new BehaviorSubject<string>('');
  public currentHref = this.hrefSource.asObservable();

  private nastavitveSource = new BehaviorSubject<boolean>(false);
  public nastavitveClickBool = this.nastavitveSource.asObservable();

  private analizaFilterSource = new BehaviorSubject<boolean>(false);
  public analizaFilterBool = this.analizaFilterSource.asObservable();

  private prodajaSettingsSource = new BehaviorSubject<boolean>(false);
  public prodajaSettingsBool = this.prodajaSettingsSource.asObservable();

  private odlagalisceFilterSource = new BehaviorSubject<boolean>(false);
  public odlagalisceFilterBool = this.odlagalisceFilterSource.asObservable();

  public curHostname;
  constructor(private http: HttpClient, private router: Router, private MY_CONSTANTS: Constants,
    private appConfigService: AppConfigServiceService, private helpersService: HelpersService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('loggedUser')));
    this.currentUser = this.currentUserSubject.asObservable();

    this.currentUsernameSubject = new BehaviorSubject<string>(localStorage.getItem('username'));
    this.helpersService.currentHostname.subscribe( data => {
      this.curHostname = data;
    });
  }


  loginUser(username: string, password: string) {
    const body = new HttpParams()
      .set('username', username)
      .set('password', password);

    // Define HttpHeaders, setting Content-Type to x-www-form-urlencoded
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      this.curHostname + this.appConfigService.api + 'projects/loginLumina', 
      body.toString(),
      { headers } // Include the headers in the request
    );
  }


  setCurrentUser(user, username) {
    localStorage.setItem('loggedUser', JSON.stringify(user));
    localStorage.setItem('username', username);
    this.currentUserSubject.next(user);
    this.currentUsernameSubject.next(username);
  }


  logout() {
    localStorage.removeItem('loggedUser');
    localStorage.removeItem('username');
    this.currentUserSubject.next(null);
    this.currentUsernameSubject.next(null);
  }

  changeHref(newHref: string) {
    this.hrefSource.next(newHref);
  }

  changeNastavitveBool(newBool: boolean) {
    this.nastavitveSource.next(newBool);
  }

  changeAnalizaFilterBool(newBool: boolean) {
    this.analizaFilterSource.next(newBool);
  }

  changeProdajaSettingsBool(newBool: boolean) {
    this.prodajaSettingsSource.next(newBool);
  }

  changeOdlagalisceFilterBool(newBool: boolean) {
    this.odlagalisceFilterSource.next(newBool);
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
}

  public get currentUsernameValue(): string {
    return this.currentUsernameSubject.value;
  }
}
